import { render } from "./Form.vue?vue&type=template&id=7881482e&scoped=true"
import script from "./Form.vue?vue&type=script&lang=js"
export * from "./Form.vue?vue&type=script&lang=js"

import "./Form.vue?vue&type=style&index=0&id=7881482e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-7881482e"

export default script